/**
 * Material-UI overrides, palette and typography definitions
 */

import { createTheme } from '@material-ui/core'

import { getPalette } from './palette'
import { getTypography } from './typography'
import { getOverrides } from './overrides'

export const getTheme = pageProps => {
  const palette = getPalette(pageProps)
  const typography = getTypography(palette)
  const overrides = getOverrides(palette)

  const theme = createTheme({
    palette,
    typography,
    overrides,
    zIndex: {
      appBar: 1200,
      drawer: 1100,
    },
  })

  return theme
}
